export default "__VITE_ASSET__C9_u8FlQ__"